import { registerErrorMiddleware, useErrorStore } from '@dott/core';

import { apolloClient } from '@/core/apollo/client';
import { resolveHomeRoute } from '@/shared/tools/home-view';
import { useAuthStore } from '@/stores/auth';

import AccessDeniedPage from '../pages/AccessDeniedPage.vue';
import NotFoundPage from '../pages/NotFoundPage.vue';
import ServerErrorPage from '../pages/ServerErrorPage.vue';
import { createRouter, createWebHistory } from 'vue-router';
import { authMiddleware } from '../middlewares/auth';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({
    top: 0,
  }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: { template: '<div />' },
      // The user's own home view (#3312) — the ONLY place it applies: every
      // sign-in, a fresh open and the error pages' way back all land on `/`,
      // while every other link keeps meaning what it says. Runs after the
      // auth middleware, so the current user is already loaded.
      beforeEnter: async () => {
        return await resolveHomeRoute(useAuthStore().user, apolloClient);
      },
      meta: {
        layout: 'main',
      },
    },
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: AccessDeniedPage,
      meta: {
        title: 'Access Denied',
        layout: 'empty',
        public: true,
      },
    },
    {
      path: '/server-error',
      name: 'ServerError',
      component: ServerErrorPage,
      meta: {
        title: 'Server Error',
        layout: 'empty',
        public: true,
      },
    },
    // Catch-all 404 route - must be registered last
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFoundPage,
      meta: {
        title: 'Page Not Found',
        layout: 'main',
      },
    },
  ],
});

// Clear stale errors first, before any guards that may set new ones
registerErrorMiddleware(router);
router.beforeEach(authMiddleware);
// router.beforeEach(permissionMiddleware);

// Handle chunk loading errors after rebuild
router.onError((error) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module')
    || error.message.includes('Importing a module script failed')
  ) {
    const errorStore = useErrorStore();
    errorStore.setError({
      statusCode: 418,
      title: 'Application Updated',
      description:
        'A new version of the application has been released. Please reload the page to get the latest updates.',
      critical: true,
    });
  }
});

export default router;
